var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00033 1.83337C6.34347 1.83337 5.00033 3.17652 5.00033 4.83337C5.00033 6.49023 6.34347 7.83337 8.00033 7.83337C9.65718 7.83337 11.0003 6.49023 11.0003 4.83337C11.0003 3.17652 9.65718 1.83337 8.00033 1.83337Z",
    fill: "#FCD23E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00083 8.50004C4.82898 8.50004 2.61193 10.8474 2.33709 13.771L2.26855 14.5H13.7331L13.6646 13.771C13.3897 10.8474 11.1727 8.50004 8.00083 8.50004Z",
    fill: "#FCD23E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateAccount);
export default __webpack_public_path__ + "static/media/create-account.d4a232a3e025ef453781526773026168.svg";
export { ForwardRef as ReactComponent };